import React from 'react';
import { AppFilterField } from './AppFilterBar';

export default function AppFilterMonthRange({
  id = 'filter-month-range',
  label = 'Période',
  value,
  onChange,
  monthOptions = [],
  yearOptions = [],
  disabled = false,
  col = 'col-12 col-md-6 col-lg-4',
  className = '',
}) {
  const startMonth = String(value?.periode_debut_mois ?? '');
  const startYear = String(value?.periode_debut_annee ?? '');
  const endMonth = String(value?.periode_fin_mois ?? '');
  const endYear = String(value?.periode_fin_annee ?? '');

  const emitChange = (field, nextValue) => {
    if (!nextValue) return;
    onChange?.({
      ...value,
      [field]: Number(nextValue),
    });
  };

  return (
    <AppFilterField col={col} label={label} htmlFor={`${id}-start-month`} className={className}>
      <div className="app-filter-month-range d-flex align-items-center gap-1 gap-md-2 flex-wrap">
        <select
          id={`${id}-start-month`}
          className="form-select form-select-sm"
          value={startMonth}
          onChange={(e) => emitChange('periode_debut_mois', e.target.value)}
          disabled={disabled}
          aria-label="Mois de début"
        >
          {monthOptions.map((option) => (
            <option key={`sm-${option.value}`} value={option.value}>{option.label}</option>
          ))}
        </select>
        <select
          id={`${id}-start-year`}
          className="form-select form-select-sm"
          value={startYear}
          onChange={(e) => emitChange('periode_debut_annee', e.target.value)}
          disabled={disabled}
          aria-label="Année de début"
        >
          {yearOptions.map((option) => (
            <option key={`sy-${option.value}`} value={option.value}>{option.label}</option>
          ))}
        </select>
        <span className="app-filter-date-range__sep text-secondary-light flex-shrink-0">→</span>
        <select
          id={`${id}-end-month`}
          className="form-select form-select-sm"
          value={endMonth}
          onChange={(e) => emitChange('periode_fin_mois', e.target.value)}
          disabled={disabled}
          aria-label="Mois de fin"
        >
          {monthOptions.map((option) => (
            <option key={`em-${option.value}`} value={option.value}>{option.label}</option>
          ))}
        </select>
        <select
          id={`${id}-end-year`}
          className="form-select form-select-sm"
          value={endYear}
          onChange={(e) => emitChange('periode_fin_annee', e.target.value)}
          disabled={disabled}
          aria-label="Année de fin"
        >
          {yearOptions.map((option) => (
            <option key={`ey-${option.value}`} value={option.value}>{option.label}</option>
          ))}
        </select>
      </div>
    </AppFilterField>
  );
}
